<template>
  <v-container elevation="0">
    <v-overlay :value="overlay" class="text-center">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
      <br />
      {{ loadingText }} {{ "(" + average + "%)" }}
    </v-overlay>
    <v-stepper
      flat
      v-model="creationActivitee"
      style="background-color: #11ffee00"
    >
      <v-row class="text-center">
        <v-col cols="12">
          <h3>Création d'une activité</h3>
        </v-col>
      </v-row>
      <v-stepper-header class="elevation-0">
        <v-stepper-step
          :complete="creationActivitee > 1 || creationActivitee < stepMax - 1"
          :step="1"
          >Données de base</v-stepper-step
        >
        <v-divider></v-divider>
        <v-stepper-step
          :complete="creationActivitee > 2 || creationActivitee < stepMax - 1"
          :step="2"
          >Description détaillée</v-stepper-step
        >
        <v-divider></v-divider>
        <v-stepper-step
          :complete="creationActivitee > 3 || creationActivitee < stepMax - 1"
          :step="3"
          >Sources bibliographiques</v-stepper-step
        >
      </v-stepper-header>
      <v-divider> </v-divider>
      <v-stepper-items>
        <v-stepper-content step="1">
          <step1
            :nextStep="nextStep"
            :saveDraft="saveDraft"
            :isDraft="$route.params.isDraft"
          ></step1>
        </v-stepper-content>
        <v-stepper-content step="2">
          <step2
            :previousStep="previousStep"
            :nextStep="nextStep"
            :saveDraft="saveDraft"
            :isDraft="$route.params.isDraft"
          ></step2>
        </v-stepper-content>
        <v-stepper-content step="3">
          <step3
            :previousStep="previousStep"
            :saveDraft="saveDraft"
            :publish="publish"
            :isDraft="$route.params.isDraft"
          ></step3>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </v-container>
</template>

<script>
import Step1 from "@/components/CreationActivitee/Step1";
import Step2 from "@/components/CreationActivitee/Step2";
import Step3 from "@/components/CreationActivitee/Step3";
import { mapActions, mapGetters } from "vuex";
import { EventBus } from "@/eventBus";

export default {
  name: "CreateActivity",
  components: { Step1, Step2, Step3 },
  created() {
    if (!this.$route.params.isDraft) {
      this.resetForm();
    }
    this.id = this.$route.params.id;
    if (this.id) {
      this.fetchDraft(this.id);
    }
  },
  computed: {
    ...mapGetters({
      uploadInProgress: "upload/getUploadInProgress",
      mediasToUpload: "upload/getMediasToUpload",
      coverToUpload: "upload/getCoverToUpload",
      average: "average"
    })
  },
  methods: {
    ...mapActions({
      addActivity: "activities/addActivity",
      addDraft: "activities/saveDraft",
      uploadMedias: "upload/uploadMedias",
      resetUpload: "upload/resetUpload",
      resetForm: "activities/resetForm",
      fetchDraft: "activities/fetchDraft"
    }),
    nextStep() {
      this.creationActivitee++;
      window.scrollTo(0, 0);
    },
    previousStep() {
      this.creationActivitee--;
      window.scrollTo(0, 0);
    },
    async saveDraft() {
      this.overlay = true;
      if (this.coverToUpload) {
        this.loadingText = "Upload de l'image de couverture...";
        await this.uploadMedias({ image: this.coverToUpload, cover: true });
      }

      if (this.mediasToUpload) {
        for (const [index, image] of this.mediasToUpload.entries()) {
          const number = index + 1;
          this.loadingText = "Upload du document n°" + number + "...";
          await this.uploadMedias({ image: image, cover: false });
        }
      }
      this.loadingText = "Ajout des données...";
      await this.addDraft();
      EventBus.$emit("showSnackBar", {
        message: "Votre brouillon a été enregistré avec succès",
        type: "success"
      });
      await this.resetUpload();
      this.overlay = false;
      this.loadingText = "";
    },
    async publish() {
      this.overlay = true;
      if (this.coverToUpload) {
        this.loadingText = "Upload de l'image de couverture...";
        await this.uploadMedias({ image: this.coverToUpload, cover: true });
      }
      if (this.mediasToUpload) {
        for (const [index, image] of this.mediasToUpload.entries()) {
          const number = index + 1;
          this.loadingText = "Upload du document n°" + number + "...";
          await this.uploadMedias({ image: image, cover: false });
        }
      }
      this.loadingText = "Ajout des données...";
      await this.addActivity();
      this.resetUpload();
      this.loadingText = "Redirection...";
      this.$router.push("/");
      this.overlay = false;
      this.loadingText = "";
    }
  },
  data() {
    return {
      stepMax: 0,
      creationActivitee: 1,
      overlay: false,
      loadingText: ""
    };
  }
};
</script>
